import reduceReducers from 'reduce-reducers'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import LocalStorage from 'redux-persist/lib/storage'

import { MENU_TITLE_INITIAL_STATE } from '../../../menu-title/redux/initial-states'
import menuTitleReducer from '../../../menu-title/redux/reducers'
import { MENU_CURATION_TASK_INITIAL_STATE } from '../initial-states'

import menuCurationTaskReducer from './menu-curation-task-reducer'
import menuCurationTasksReducer from './menu-curation-tasks-reducer'
import targetedDbFlashReducer from './targeted-db-flash-reducer'

export default combineReducers({
  menuCurationTasks: persistReducer(
    {
      key: 'menuCurationTasks',
      storage: LocalStorage,
      whitelist: ['persistedFilters'],
    },
    menuCurationTasksReducer,
  ),
  menuCurationTask: reduceReducers(
    { ...MENU_TITLE_INITIAL_STATE, ...MENU_CURATION_TASK_INITIAL_STATE },
    menuTitleReducer,
    menuCurationTaskReducer,
  ),
  targetedDbFlash: targetedDbFlashReducer,
})
